export type TPlatform = 'windows' | 'android' | 'ios' | 'unknown' | 'app';

export const getMobileOperatingSystem = (): TPlatform => {
    const userAgent = navigator.userAgent;

    if (/android/i.test(userAgent)) {
        return 'android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return 'ios';
    }

    return 'unknown';
}

export const isMobileApp = () => /ismet-mobile/.test(navigator.userAgent);

export const screen_breakpoint_xs = 600;
export const screen_breakpoint_sm = 960;
export const screen_breakpoint_md = 1280;
export const screen_breakpoint_lg = 1920;
export const screen_breakpoint_xl = 2560;

export const sendAction = (message: string) => {
    try {
        const data = {
            type: 'action',
            message: message
        };
        (window as any).ReactNativeWebView?.postMessage(JSON.stringify(data));
    } catch {
    }
}